import SessionEventProto from "../session-event-proto"

import {SESSION_PROJECT_CHANGE} from "../../gd/bus/bus-event-type"
import asyncSessionLoader from "../../gd/data/async-session-loader"

// const debug = "SessionProjectMove"
const debug = false

export default class SessionProjectMove extends SessionEventProto {

    public header: {
        project     : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)

        this.header     = {
            project     : sessionEvent.project,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    async process() {
        if (this.isDifferentCompany()) return false

        await this._updateSessionCollection() // gd.session.projects
        this._updateTemplatesCollection() // gd.session.templatesList
        this._sendBusUpdate()
    }

    async _updateSessionCollection() {
        const sessionProject = gd.session.projects.get(this.header.project.id)

        if (sessionProject) {
            sessionProject.applyDelta({parentId: this.data.parentId})
            // ToDo: update only projects that are affected by MOVE instead of reinit whole tree
            gd.session.projects.initTree()

            // yes trigger via bus ... as we start using bus only here we use it to update title in project header (project title)
            gd.bus.triggerEvent(SESSION_PROJECT_CHANGE,this.header.project.id)

            let statuses = this.data.taskStatusesOverride ? this.data.taskStatusesOverride : []

            await asyncSessionLoader(gd.session.findMissing({
                projects: [this.data.localTemplateId],
                statuses: statuses
            }))

            // let's recreate the tree ?
            gd.tree.resetCompanyProjects(sessionProject.companyId)
        }
    }

    _updateTemplatesCollection() {
        const sessionTemplate = gd.session.templatesList.get(this.header.project.id)

        if (sessionTemplate) {
            sessionTemplate.set({parentId: this.data.parentId},{silent:true, parse:true})
            sessionTemplate.trigger("change", sessionTemplate)
        }
    }

    _sendBusUpdate() {
        gd.modelBus.newUpdate('project', this.method, this.header.project.id, this.data, this.header)
    }
}